import { useState, useEffect } from 'react';
import useChat from '../../hooks/useChat';
import ChatPanel from './ChatPanel';

const MARKETPLACE_TYPE_LABELS: Record<string, string> = {
  for_rent: 'Renta',
  for_sale: 'Venta',
};

interface Props {
  propertyCode: string;
  availableTypes: string[];
}

const FloatingChat = ({ propertyCode, availableTypes }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(availableTypes[0]);
  const chatRent = useChat();
  const chatSale = useChat();
  const {
    messages,
    isLoading,
    isInitialized,
    sendMessage,
    initChat,
    clearMessages,
  } = selectedType === 'for_rent' ? chatRent : chatSale;

  useEffect(() => {
    if (isOpen && !isInitialized && propertyCode) {
      initChat(propertyCode, selectedType);
    }
  }, [isOpen, isInitialized, propertyCode, selectedType, initChat]);

  const handleTypeChange = (type: string) => {
    if (type === selectedType) return;
    setSelectedType(type);
  };

  return (
    <ChatPanel
      messages={messages}
      isLoading={isLoading}
      isInitialized={isInitialized}
      isOpen={isOpen}
      onToggle={() => setIsOpen((o) => !o)}
      onSend={sendMessage}
      onClear={clearMessages}
      tabs={{
        options: availableTypes,
        selected: selectedType,
        onChange: handleTypeChange,
        labels: MARKETPLACE_TYPE_LABELS,
      }}
    />
  );
};

export default FloatingChat;
